<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<em class="lt_text">Date of Approval</em>
				<span class="mgr_5"> <CustomDatePicker v-model="date"/></span>
				<template v-if="viewableBySalesman">
					<SalesGroup v-model="sales_group_code" ref="salesGroup" :allSelect="false" />
					<label class="mgr_15"><input type="checkbox" v-model="by_salesman" /> By Salesman</label>
				</template>
				<a href="javascript:void(0);" class="search_bt" @click="selectData()">Search</a>
			</div>
		</div>

		<div class="fixed-table-container-none-padding">
			<div class="table-wrapper" style="height: 90%; overflow-x: auto;">
				<table class="list_tbl sticky_list_tbl" id="excelTable">
					<colgroup>
						<col style="width: 50px;" />
						<col style="width: 100px;" />
						<col v-for="index in root.salesGroupList.length" v-bind:key="index" />
					</colgroup>
					<thead>
						<tr v-if="Array.isArray(root.salesGroupHeader)">
							<th colspan="2"></th>
							<th v-for="(gh, index) in root.salesGroupHeader" :key="index + 'gh'" :colspan="gh.colspan" class="th_left_border">{{ gh.sales_group_name }}</th>
						</tr>
						<tr>
							<th colspan="2">No</th>
							<th v-for="sales in root.salesGroupList" v-bind:key="'h' + sales.sales_group_code">
								{{ sales.sales_group_name }}
							</th>
						</tr>
					</thead>
					<tbody>
						<template v-for="list1 in root.list">
							<tr v-bind:key="'i' + list1.row_index.toString()">
								<td class="al_center" rowspan="3">{{ list1.row_index }}</td>
								<td class="al_center">Sales Order</td>
								<template v-for="sales in root.salesGroupList">
									<template v-if="list1.list.filter(invoice => (invoice.sales_group_code || null) === sales.sales_group_code).length > 0">
										<td v-for="a in list1.list.filter(invoice => (invoice.sales_group_code || null) === sales.sales_group_code)" :key="'inv' + a.invoice_no.toString()" class="al_right">
											<a href="javascript:void(0)" @click="selectInvoice(a.invoice_no)"> {{ a.total_amount | toCurrency }}</a>
										</td>
									</template>
									<template v-else>
										<td :key="'i' + list1.row_index.toString() + sales.sales_group_code"></td>
									</template>
								</template>
							</tr>
							<tr v-bind:key="'a' + list1.row_index.toString()">
								<td class="al_center">Avail</td>
								<template v-for="sales in root.salesGroupList">
									<template v-if="list1.list.filter(invoice => (invoice.sales_group_code || null) === sales.sales_group_code).length > 0">
										<td v-for="a in list1.list.filter(invoice => (invoice.sales_group_code || null) === sales.sales_group_code)" :key="'a' + a.invoice_no.toString()" class="al_right">
											{{ a.total_valid_amount | toCurrency }}
										</td>
									</template>
									<template v-else>
										<td :key="'a' + list1.row_index.toString() + sales.sales_group_code"></td>
									</template>
								</template>
							</tr>
							<tr v-bind:key="'q' + list1.row_index.toString()">
								<td class="al_center">Avail Quantity</td>
								<template v-for="sales in root.salesGroupList">
									<template v-if="list1.list.filter(invoice => (invoice.sales_group_code || null) === sales.sales_group_code).length > 0">
										<td v-for="a in list1.list.filter(invoice => (invoice.sales_group_code || null) === sales.sales_group_code)" :key="'q' + a.invoice_no.toString()" class="al_right">
											{{ a.total_valid_quantity | commaSeparated }}
										</td>
									</template>
									<template v-else>
										<td :key="'q' + list1.row_index.toString() + sales.sales_group_code"></td>
									</template>
								</template>
							</tr>
						</template>
						<tr>
							<td rowspan="3" colspan="2" class="al_center">Total</td>
							<td class="al_right" v-for="sales in root.salesGroupList" :key="sales.sales_group_code">
								{{ sales.total_amount | toCurrency }}
							</td>
						</tr>
						<tr>
							<td class="al_right" v-for="sales in root.salesGroupList" :key="sales.sales_group_code">
								{{ sales.total_valid_amount | toCurrency }}
							</td>
						</tr>
						<tr>
							<td class="al_right" v-for="sales in root.salesGroupList" :key="sales.sales_group_code">
								{{ sales.total_valid_quantity | commaSeparated }}
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>

		<div class="al_center" style="margin: 0 auto;">
			<label class="mgr_5">
				<em class="lt_text">Total Amount</em>
				<input type="text" autocomplete="off" class="tbl_int ssm2_int al_right" disabled="disabled" v-bind:value="root.total_amount | toCurrency" />
			</label>
			<label class="mgr_5">
				<em class="lt_text">Total Avail Amount</em>
				<input type="text" autocomplete="off" class="tbl_int ssm2_int al_right" disabled="disabled" v-bind:value="root.total_valid_amount | toCurrency" />
			</label>
			<label class="mgr_5">
				<em class="lt_text">Total Avail Quantity</em>
				<input type="text" autocomplete="off" class="tbl_int ssm2_int al_right" disabled="disabled" v-bind:value="root.total_valid_quantity | commaSeparated" />
			</label>
		</div>
		<div class="bottom_bt_box">
			<ul>
				<li>
					<a href="javascript:void(0);" v-on:click="reportPrint">Print</a>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import { apiSalesOrderList } from '@/api/report/report';
import { invoicePageGo, objectToFormData, reportMrtUrl, reportRender } from '@/api/util';
import { today } from '@/utils/date';
import CustomDatePicker from '@/components/common/CustomDatePicker';
import SalesGroup from '@/components/common/SalesGroup';

export default {
	data: function() {
		return {
			root: {
				salesGroupList: [],
				list: [],
			},
			date: today(),
			sales_group_code: null,
			by_salesman: false,
			tdChecker: false,
		};
	},
	computed: {
		user: function() {
			return this.$session.get('user');
		},
		company_id() {
			return this.user ? this.user.company_id : null;
		},
		viewableBySalesman() {
			return this.company_id === 'beautyplus' || this.company_id === 'hairplus';
		},
	},
	methods: {
		makeDisplay(value) {
			const list = value.list;
			if (Array.isArray(list) && this.by_salesman) {
				for (const idx_invoices of list) {
					if (!Array.isArray(idx_invoices.list)) continue;

					for (const inv of idx_invoices.list) {
						inv.sales_group_code = inv.sales_group_code + '/' + inv.salesman_id;
						inv.sales_group_name = inv.salesman_name;
					}
				}
			}

			const salesGroupList = value.salesGroupList;
			let salesGroupHeader = null;
			if (Array.isArray(salesGroupList) && this.by_salesman) {
				salesGroupHeader = [];
				for (const sales_group of salesGroupList) {
					const idx = salesGroupHeader.findIndex(sgh => sgh.sales_group_code === sales_group.sales_group_code);
					if (idx > -1) salesGroupHeader[idx].colspan++;
					else salesGroupHeader.push({ sales_group_code: sales_group.sales_group_code, sales_group_name: sales_group.sales_group_name, colspan: 1 });

					sales_group.sales_group_code = sales_group.sales_group_code + '/' + sales_group.salesman_id;
					sales_group.sales_group_name = sales_group.salesman_name;
				}
			}

			return {
				list: list,
				salesGroupList: salesGroupList,
				salesGroupHeader: salesGroupHeader,
				date: value.date,
				total_amount: value.total_amount,
				total_valid_amount: value.total_valid_amount,
				total_valid_quantity: value.total_valid_quantity,
			};
		},
		async selectData() {
			const paramObj = {
				date: this.date,
				sales_group_code: this.sales_group_code || '',
				by_salesman: this.by_salesman,
			};
			const param = objectToFormData(paramObj);
			const { data } = await apiSalesOrderList(param);
			if (data && data.value) {
				this.root = this.makeDisplay(data.value);
			} else {
				this.root = {
					salesGroupList: [],
					list: [],
				};
			}
		},
		selectInvoice(invoiceNo) {
			invoicePageGo(invoiceNo);
		},
		async reportPrint() {
			await reportRender(this.root, 'SalesList', reportMrtUrl('SalesList'));
		},
	},
	components: {
		CustomDatePicker,
		SalesGroup,
	},
	mounted() {
		this.$store.commit('setSideIndex', 7);
		this.$store.commit('setSelectedMenu', 'nav_li_salesOrder');
		this.$store.commit('setSubTitle', 'Report -> Daily Sales Order');
	},
};
</script>

<style scoped lang="scss">
.list_tbl thead th.th_left_border {
	border-left: 2px solid #c9c9c9;
}
</style>
